<div  id="containerFoto" class="container">
        <img class="background-foto" src="../../../assets/images/5_Itinerari-esperienze/5_Itinerari-esperienze-Aspromonte_top.jpg">
    <div class="content">
        <h1>Calabria</h1>
        <h3>Esperienze e Itinerari</h3>
    </div>
</div>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            La Calabria è una regione unica per varietà di paesaggi e storie. Una terra ricca di risorse naturali, millenario crocevia di culture, lingue, 
            tradizioni, che fanno di questo territorio una meta ideale per turisti e viaggiatori appassionati di esperienze coinvolgenti ed emozionanti.
            <br>
            <br>
            A piedi, in bici, a cavallo, con qualunque mezzo la Calabria offre itinerari e percorsi mozzafiato, dal mare alla montagna, 
            in ogni stagione: una rete di cammini di oltre mille chilometri, tra Sentiero Italia e Calabria, 
            i Cammini di San Francesco da Paola e quello di Gioacchino da Fiore, il Sentiero dell’inglese e quello del brigante, 
            a cui fa eco la Ciclovia dei Parchi che attraversa per intero la dorsale appenninica da Laino Borgo a Reggio Calabria.
            <br>
            <br>
            Natura e benessere, Storia, arte e spiritualità, Gusto e tradizioni, 
            si ritrovano lungo questi magnifici tracciati alla scoperta della Calabria più autentica.            
        </p>
    </div>
</div>
<!-- <div class="formItinerario" style="margin-top: 30px;">
    
    <div class="row">
        <h1>Sai già cosa scegliere?</h1>
    </div>
    <div>
        <form>
            <div class="row">
                <div class="col">
                    <label for="attivita">Attività
                        <select id="attivita" class="form-select" aria-label="Default select example" name="attivita">
                            <option selected>Seleziona attività</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </select>
                    </label>
                </div>
                <div class="col">
                    <label for="durata">Durata giorni
                        <select id="durata" class="form-select" aria-label="Default select example" name="durata">
                            <option selected>Seleziona durata</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </select>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label for="adulti">Numero Adulti
                        <select id="adulti" class="form-select" aria-label="Default select example" name="adulti">
                            <option selected>Seleziona numero adulti</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </select>
                    </label>
                </div>
                <div class="col">
                    <label for="livello">Livello difficoltà
                        <select id="livello" class="form-select" aria-label="Default select example" name="livello">
                            <option selected>Seleziona livello difficoltà</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </select>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label for="bambini">Numero bambini
                        <select id="bambini" class="form-select" aria-label="Default select example" name="bambini">
                            <option selected>Seleziona numero bamini</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </select>
                    </label>
                </div>
                <div class="col">
                    <div class="form-check">
                        <label for="guida">Richiesta Guida
                            <input class="form-check-input" type="checkbox" value="" id="guida">
                        </label>
                      </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <label for="luogo">Luogo
                        <select id="luogo" class="form-select" aria-label="Default select example" name="luogo">
                            <option selected>Seleziona luogo</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </select>
                    </label>
                </div>
                <div class="col-3">
                    <div class="form-group">
                        <label class="active" for="dateStandard">Dal</label>
                        <input type="date" id="dateStandard" name="dateStandard">
                    </div>
                </div>
                <div class="col-3">
                    <div class="form-group">
                        <label class="active" for="dateStandard">Al</label>
                        <input type="date" id="dateStandard" name="dateStandard">
                    </div>
                </div>
            </div>
        </form>
    </div>
</div> -->
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Cammini<br />e outdoor</h1>
                        <a (click)="goToCammini()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Cicloturismo</h1>
                        <a (click)="goToCicloturismo()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Natura<br />e benessere</h1>
                        <a (click)="goToNatura()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-12 col-xl-3 four" id="four">
            <div class="card four">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Storia, arte e 
                            <br /> spiritualità</h1>
                        <a (click)="goToStoria()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 five" id="five">
            <div class="card five">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gusto e<br />tradizioni</h1>
                        <a (click)="goToGusto()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 six" id="six">
            <div class="card six">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Itinerari<br />didattici</h1>
                        <a (click)="goToItinerariDidattici()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>